import React, { Component } from "react";
import { BarChart, Card } from "ui-kit-ck-consultant";

import PerimeterBadge from "./PerimeterBadge";

import { getCurrencyValue } from "../../utils/general";

const formatCurrency = (value) => {
  const n = Number(value);
  return getCurrencyValue(Number.isFinite(n) ? n : 0);
};

export class CA extends Component {
  render() {
    const labels = this.props.data.labels || [];
    const CA = (this.props.data && this.props.data.CA) || {};
    const series = (CA.CAByMonth || []).map((v) => Number(v) || 0);
    const goalSeries = (CA.goalByMonth || []).map((v) => Number(v) || 0);
    const hasGoal = goalSeries.some((v) => v > 0);
    const total = Number.isFinite(CA.total)
      ? CA.total
      : series.reduce((acc, v) => acc + v, 0);
    const goalTotal = Number.isFinite(CA.goal)
      ? CA.goal
      : goalSeries.reduce((acc, v) => acc + v, 0);

    return (
      <Card
        className="mb-10"
        title="Chiffre d'affaires"
        action={
          <span
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              fontSize: "12px",
              color: "#6b7280",
              fontWeight: 500,
            }}
          >
            <span>
              {formatCurrency(total)}
              {hasGoal ? ` / ${formatCurrency(goalTotal)}` : ""} · 6 derniers
              mois
            </span>
            {this.props.perimeter && (
              <PerimeterBadge perimeter={this.props.perimeter} compact />
            )}
          </span>
        }
      >
        <BarChart
          format="currency"
          labels={labels}
          widthBar={30}
          dataSet={
            hasGoal
              ? [
                  {
                    label: "CA",
                    data: series,
                    color: "#026fc2",
                  },
                  {
                    label: "Atteinte",
                    data: series.map((v, idx) => v - (goalSeries[idx] || 0)),
                    color: series.map((v, idx) =>
                      v - (goalSeries[idx] || 0) > 0 ? "#238037" : "#ea0000",
                    ),
                  },
                  {
                    label: "Objectif",
                    type: "line",
                    data: goalSeries,
                    color: "#026fc2",
                  },
                ]
              : [
                  {
                    label: "CA",
                    data: series,
                    type: "bar",
                    color: "#E68A00",
                  },
                ]
          }
          xAxes={[
            {
              stacked: hasGoal,
            },
          ]}
          yAxes={[
            {
              stacked: hasGoal,
              ticks: {
                display: false,
              },
            },
          ]}
        />
      </Card>
    );
  }
}

export default CA;
